import { useMemo } from "react";

const LastSavedIndicator = ({
  lastSaved,
  isSaving,
  hasPendingChanges,
  hasSaveError,
}) => {
  const mode = useMemo(() => {
    if (hasSaveError) return "error";
    if (isSaving) return "saving";
    if (hasPendingChanges) return "pending";
    if (lastSaved) return "saved";
    return "idle";
  }, [hasSaveError, isSaving, hasPendingChanges, lastSaved]);

  const title = useMemo(() => {
    if (mode === "error") return "Save error. Check your data";
    if (mode === "saving") return "Saving...";
    if (mode === "pending") return "Pending changes";
    if (mode === "saved") return "Saved";
    return "";
  }, [mode]);

  if (mode === "idle") return null;

  const size = 22;

  return (
    <div className="mr-2 flex items-center" title={title}>
      {mode === "error" && (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          className="text-red-600"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
          <path
            d="M12 6.5v7"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="12" cy="17.5" r="1.2" fill="currentColor" />
        </svg>
      )}

      {mode === "saving" && (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          className="animate-spin text-[#5C4BF5]"
          aria-hidden="true"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeOpacity="0.25"
          />
          <path
            d="M22 12a10 10 0 0 0-10-10"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )}

      {mode === "saved" && (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          className="text-green-600"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
          <path
            d="M7 12.5l3 3 7-8"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}

      {mode === "pending" && (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
          <circle 
            cx="12" 
            cy="12" 
            r="10" 
            fill="none" 
            stroke="#5C4BF5" 
            strokeWidth="2" 
            strokeDasharray="4 4"
          />
          <circle cx="12" cy="12" r="1.6" fill="#6B7280" />
        </svg>
      )}
    </div>
  );
};

export default LastSavedIndicator;
